// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3Rfho","footer":"ModalCreateQualiphyProcedure_footer__3lrPO","additionData":"ModalCreateQualiphyProcedure_additionData__3lHqF"};